import React, { useEffect, useState } from 'react';
import { PlusCircleOutlined, DeleteFilled } from '@ant-design/icons';
import { Button, Input, Select, Tag } from 'antd';
import InfrastructureService from '../../../../domain/Infrastructure/InfraestructureService';

const infrastructureService = new InfrastructureService();

export default function UploadHydroTwinStep({
  digitalTwinData,
  onNext,
  onCancel,
}: any) {
  const [hydroTwinName, setHydroTwinName] = useState('');
  const [selectedParameter, setSelectedParameter] = useState<any>(null);
  const [selectedInfrastructure, setSelectedInfrastructure] = useState<any>(null);
  const [infrastructures, setInfrastructures] = useState<any[]>([]);
  const [parameters, setParameters] = useState<any[]>([]);
  const [variables, setVariables] = useState<any[]>([]);
  const selectedInfrastructureId = selectedInfrastructure
    ? JSON.parse(selectedInfrastructure).infraestructureId
    : null;

  async function handleSearchInfrastructures() {
    const response = await infrastructureService.getInfraestructureInUse(
      `${digitalTwinData.locationId}`,
      1,
      1000,
      '',
      null,
      0,
      null,
    );
    setInfrastructures(response.data);
  }

  function handleSetParameters(val: any) {
    const selectedInfra = infrastructures.find(
      (item) => item.infraestructureId === val,
    );
    if (!selectedInfra) {
      setParameters([]);
      return;
    }
    setParameters(selectedInfra.measurementParameters || []);
  }

  useEffect(() => {
    handleSearchInfrastructures();
  }, []);

  useEffect(() => {
    if (!selectedInfrastructure) {
      setParameters([]);
      return;
    }

    handleSetParameters(JSON.parse(selectedInfrastructure).infraestructureId);
  }, [infrastructures, selectedInfrastructure]);

  return (
    <div className="flex column" style={{ height: '100%' }}>
      <div className="flex column">
        <span className="mt-2">Name of HydroTwin</span>
        <Input
          value={hydroTwinName}
          onChange={(e) => {
            setHydroTwinName(e.target.value);
          }}
        />
        <span className="mt-4">Input Parameters</span>
        <div className="flex mb-3 mt-1">
          <Select
            id="upload-hydrotwin-infrastructure"
            placeholder="Infrastructure"
            value={selectedInfrastructure}
            notFoundContent={null}
            onChange={(val) => {
              setSelectedInfrastructure(val);
              setSelectedParameter(null);
            }}
            style={{ minWidth: '200px' }}
            showSearch
            options={(infrastructures || []).map((item) => ({
              value: JSON.stringify(item),
              label: item.infraestructureName,
            }))}
            className="mr-1"
          />
          <Select
            id="upload-hydrotwin-parameter"
            placeholder="Parameter"
            value={selectedParameter}
            onChange={(val) => {
              setSelectedParameter(val);
            }}
            style={{ minWidth: '200px' }}
            options={(parameters || [])
              .filter((item) => {
                return (
                  variables.findIndex(
                    (variable) =>
                      variable.parameterId === item.paremeterId &&
                      variable.infraId === selectedInfrastructureId,
                  ) < 0
                );
              })
              .map((item) => ({
                value: JSON.stringify(item),
                label: item.paremeterName,
              }))}
            className="mr-1"
          />
          <Button
            type="primary"
            shape="round"
            icon={<PlusCircleOutlined rev={undefined} />}
            className="flex items-center ml-auto"
            style={{
              backgroundColor: '#023E65',
              borderColor: '#023E65',
              color: 'white',
              width: '120px',
              height: '32px',
            }}
            onClick={() => {
              const parameter = JSON.parse(selectedParameter);
              const infrastructure = JSON.parse(selectedInfrastructure);

              setVariables((prev: any) => [
                ...prev,
                {
                  parameterName: parameter.paremeterName,
                  parameterId: parameter.paremeterId,
                  infraName: infrastructure.infraestructureName,
                  infraId: infrastructure.infraestructureId,
                },
              ]);
              setSelectedParameter(null);
            }}
            disabled={!selectedInfrastructure || !selectedParameter}
          >
            Add input
          </Button>
        </div>
        <div className="flex border border-gray-200 rounded p-2 overflow-x-auto overflow-y-scroll max-h-[100px] scrollbar-thin scrollbar-track-gray-200 scrollbar-thumb-gray-400 flex-wrap">
          {variables.map((variable) => {
            const tagKey = `${variable.infraId}-${variable.parameterId}`;
            return (
              <Tag
                color="#E8F9FF"
                className="mr-1 mb-1 h-[25px] rounded-3xl font-bold text-center"
                style={{
                  color: '#023E65',
                  fontWeight: 'bold',
                  borderRadius: '20px',
                  height: '25px',
                }}
                key={tagKey}
              >
                {`${variable.infraName} - ${variable.parameterName}`}
                <DeleteFilled
                  onClick={() => {
                    setVariables((prev) =>
                      prev.filter(
                        (item) =>
                          `${item.infraId}-${item.parameterId}` !== tagKey,
                      ),
                    );
                  }}
                  className="ml-2 cursor-pointer text-red-500"
                  rev={undefined}
                />
              </Tag>
            );
          })}
        </div>
      </div>
      <div className="flex mt-4 justify-end">
        <Button
          className="bg-[#00203C] text-white h-[40px]"
          onClick={() => {
            onNext({
              name: hydroTwinName.trim(),
              variables,
            });
          }}
          disabled={variables.length < 1 || hydroTwinName.trim() === ''}
        >
          Next
        </Button>
        <Button
          className="ml-3 h-[40px]"
          onClick={() => {
            onCancel();
          }}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}
